<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>视频管理</el-breadcrumb-item>
      <el-breadcrumb-item>视频设置</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <div class="conentRow">
        <el-input v-model="searchName" placeholder="视频名称" clearable />
        <el-button type="primary" @click="searchFn">查询</el-button>
      </div>
      <el-table
        :data="videoListData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="videoname" label="视频名称"></el-table-column>
        <el-table-column prop="" label="上传时间">
          <template slot-scope="scope">
            <span v-if="scope.row.CreateTime=='0000-00-00 00:00:00'"></span>
            <span v-else>{{ scope.row.CreateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="videokey" label="关键词"></el-table-column>
        <el-table-column prop="type" label="分类"></el-table-column>
        <el-table-column prop="address" label="操作" width="400">
          <template slot-scope="scope">
            <el-button class="deleCss" type="text" @click="deleFn(scope.row)">删除</el-button>
            <el-button type="text" @click="editFn(scope.row)">编辑</el-button>
            <el-button type="text" @click="topFn(scope.row)">置顶</el-button>
            <el-button type="text" @click="forwardFn(scope.row,1)">前移一位</el-button>
            <el-button type="text" @click="forwardFn(scope.row,2)">后移一位</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="videoListPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{videoListPar.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->
        <!-- 信息上下线弹框开始 -->
        <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="s=videoDialogVisible"
      :before-close="videoHandleClose"
      width="32%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="80px" :model="addVideoData">
        <el-form-item label="视频名称:">
          <span class="absPosiE">*</span>
          <el-input v-model="addVideoData.videoName"></el-input>
        </el-form-item>
        <div class="itemDiv videoITEM">
          <el-form-item label="视频文件:">
            <span class="absPosiA">*</span>
            <el-input v-model="addVideoData.videoFile"></el-input>
          </el-form-item>
          <el-upload
              class="upload-demo"
              action="http://xwt.softykt.net/api/jfy/uploadVideo"
              :on-success="handlePreviewVide"
              :limit="limit"
              :before-upload="beforeUploadVideo"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </div>
        <div class="itemDiv itemNotes">
          <el-form-item label="封面图:">
            <span class="absPosiB">*</span>
            <!-- <el-input v-model="addVideoData.coverImg " placeholder="选择文件"></el-input> -->
            <el-upload
              class="upload-demo"
              action="http://xwt.softykt.net/api/jfy/uploadVideoImg"
              :on-success="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :limit="limit"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip zhu">注：文件格式png、jpg；大小308*174;封面图每个分类传一张即可! 如需修改请先删除原封面</div>
            </el-upload>
          </el-form-item>
          <!-- <el-button class="btnL">开始上传</el-button> -->
        </div>
        <!-- <div class="notesDiv">注：文件格式png、jpg；大小308*174;封面图每个分类传一张即可</div> -->
        <el-form-item label="关键词:">
          <span class="absPosiC">*</span>
          <el-input v-model="addVideoData.keyWord"></el-input>
          <div class="notes">注：关键词可用"/"分割开</div>
        </el-form-item>

        <el-form-item label="分类:">
          <span class="absPosiD">*</span>
          <el-input v-model="addVideoData.type"></el-input>
        </el-form-item>

        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button @click="uploadQk">清空</el-button>
          <el-button class="btnL" @click="uploadFn()">确认上传</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
 
  </div>
</template>

<script>
import {
  getVideoConfigListPost,
  videoConfigDeletePost,
  videoTopPost,
  updateVideo,
  getVideoInfo,
  videoMove
} from "@/request/video.js";
import { MessageBox,Message } from 'element-ui';
export default {
  components: {},
  data() {
    return {
     fileList: [
    ],
      videoDialogVisible: false, // 上传视频弹框
        // 上传视频绑定数据
      addVideoData: {
        videoName: "",
        videoFile: "",
        coverImg: "",
        keyWord: "",
        type: "",
        videoid:'',
      },
      stateDialogVisible: false, // 状态弹框
      // 列表传参
      videoListPar: {
        token: "",
        video_name: "",
        type: "",
        page: 1,
        page_size: 8
      },
      // 列表数据
      videoListData: [],
      total: 1,
      searchName: "", // 搜索
      imgXl: require("@/images/scenic/sj.png"),
      imgXlb: require("@/images/scenic/sjh.png"),
      tableData: [
      
      ],
      options: [
      
      ],
      value: "",
      radio: "",
      limit:1
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.videoListPar = {
      token: this.Token,
      video_name: "",
      type: "",
      page: 1,
      page_size: 8
    };
    this.getList(this.videoListPar);
  },
  methods: {
    beforeUploadVideo(file){
      if (['video/mp4', 'video/ogg','video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
        Message.error('上传视频只能是 mp4、ogg、flv、avi、wmv、rmvb 格式!');
        return false;
      }
      return true;
    },
    uploadQk(){
      this.addVideoData = {
        videoName: "",
        videoFile: "",
        coverImg: "",
        keyWord: "",
        type: ""
      }
      this.fileList = []
    },
    // 获取列表数据
    getList(data) {
      getVideoConfigListPost(data).then(res => {
        this.videoListPar.page = res.data.result.current_page
        this.videoListData = res.data.result.data;
        console.log(this.videoListData);
        this.total = res.data.result.total;
      });
    },
    // 搜索
    searchFn() {
      this.videoListPar.page = 1;
      this.videoListPar.video_name = this.searchName;
      this.getList(this.videoListPar);
    },
    // 点击前移
    forwardFn(row,scope) {
      if(scope=='1'){
        this.videoListData.map((item,index)=>{
          if(item.videoid==row.videoid){
            if(index-1<0){
              Message.error('第一位不可前移')
              return false
            }
            let data = {
              videoid:row.videoid,
              move_videoid:this.videoListData[index-1].videoid,
              token: window.sessionStorage.getItem("Token")
            }
            videoMove(data).then(res=>{
              if(res.data.status=='ok'){
                Message.success('前移一位成功')
                this.getList(this.videoListPar);
              }
            })
          }
        })
      }else{
        this.videoListData.map((item,index)=>{
          if(item.videoid==row.videoid){
            if(index+1==this.videoListData.length){
                Message.error('最后一位不可后移')
                return false
            }
            let data = {
              videoid:row.videoid,
              move_videoid:this.videoListData[index+1].videoid,
              token: window.sessionStorage.getItem("Token")
            }
            videoMove(data).then(res=>{
              if(res.data.status=='ok'){
                Message.success('后移一位成功')
                this.getList(this.videoListPar);
              }
            })
          }
        })
      }
      return false
      let upData = {
        videoid: row.videoid,
        token: this.Token
      };
      MessageBox("确定前移一位?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          videoConfigDeletePost(upData).then(res => {
            console.log(res);
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              let upData = {
                token: this.Token
              };
              this.getList(upData);
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消移动"
          });
        });
    },
    // 点击删除
    deleFn(row) {
      let upData = {
        videoid: row.videoid,
        token: this.Token
      };
      MessageBox("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          videoConfigDeletePost(upData).then(res => {
            console.log(res);
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              let upData = {
                token: this.Token
              };
              this.getList(upData);
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 点击置顶
    topFn(row) {
      let upData = {
        videoid: row.videoid,
        token: this.Token
      };
      MessageBox("确定置顶?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          videoTopPost(upData).then(res => {
            console.log(res);
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              let upData = {
                token: this.Token
              };
              this.getList(upData);
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消置顶"
          });
        });
    },
    // 点击详情编辑
    editFn(row) {
      this.videoDialogVisible = true;
    
      let data = {
        token: this.Token,
        videoid:row.videoid
      }
      getVideoInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.addVideoData = {
              videoName:res.data.result.videoname,
              videoFile: res.data.result.videourl,
              coverImg: res.data.result.pictureurl,
              keyWord: res.data.result.videokey,
              type: res.data.result.type,
              videoid:row.videoid
          }
         
          this.fileList.push( {name: '', 
            url: res.data.result.pictureurl}, )
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.videoListPar.page = val;
      this.getList(this.videoListPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    handleRemove(file ) {
      console.log(file);
    },
    handlePreview(file) {
      this.addVideoData.coverImg = file.result
    },
    handlePreviewVide(file){
      this.addVideoData.videoFile = file.result
    },
    // 上传视频X
    videoHandleClose() {
      this.fileList = []
      this.videoDialogVisible = false;
    },
      // 确认上传
   uploadFn() {
      if( this.addVideoData.videoName==''){
        Message.error('用户名为空')
        return false
      }else if(this.addVideoData.keyWord==''){
        Message.error('关键字为空')
        return false
      }else if(this.addVideoData.videoFile==''){
        Message.error('视频未上传')
        return false
      }else if(this.addVideoData.coverImg==''){
        Message.error('视频封面未上传')
        return false
      }else if(this.addVideoData.type==''){
        Message.error('分类为空')
        return false
      }
      this.addVideoPar = {
        token: this.Token,
        videoname: this.addVideoData.videoName, // 用户名
        videokey: this.addVideoData.keyWord, // 关键字
        videourl: this.addVideoData.videoFile, // 视频地址
        type: this.addVideoData.type, // 分类
        pictureurl: this.addVideoData.coverImg, // 视频封面地址
        videoid:this.addVideoData.videoid
      };
      updateVideo(this.addVideoPar).then(res => {
        console.log(res);
        if(res.data.status=='ok'){
          Message.success('修改成功')
          this.getList(this.videoListPar)
          this.videoDialogVisible = false
          this.addVideoData.videoid = ''
          this.fileList = []
        }else{
          if(res.data.msg==''){
            Message.error('数据未修改')
          }else{
            Message.error(res.data.msg)
          }
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.deleCss {
  color: #ff4d4f;
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  // height: 80vh;
  margin-top: 17px;
  .conentRow {
    margin-bottom: 20px;
    .el-input {
      width: 240px;
      margin-right: 20px;
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}
.scenicBtn {
  // width: 596px;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  margin-left: 42px;
  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    // margin-right: -272px;
    // line-height: 20px;
    /* identical to box height */

    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.editForm {
  .itemNotes {
    position: relative;
    margin-bottom: 20px;
  }
  .zhu {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ff4d4f;
  }
  .notesDiv {
    margin-top: 7px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ff4d4f;
    position: absolute;
    top: 245px;
    left: 100px;
  }
  .notes {
    margin-top: 7px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height */
    color: #ff4d4f;
  }

  .itemDiv {
    display: flex;
    // flex-wrap: wrap;
    .el-input {
      // width: 300px;
      /deep/.el-input__inner {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #000000;
      }
    }
    .el-button {
      width: 100px;
      height: 40px;
      margin-left: 20px;
      background: #006afa;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      border: none;
      color: #ffffff;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    /deep/.el-button {
      width: 100px;
      background: #ffffff;
      border: 1px solid #ff4d4f;
      border-radius: 4px;
      box-sizing: border-box;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ff4d4f;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-dialog{
  height: auto !important;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #ff4d4f;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #ff4d4f;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #ff4d4f;
}
.absPosiC {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #ff4d4f;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -51px;
  color: #ff4d4f;
}
.videoITEM /deep/ .el-upload-list{
  display: none;
}
/deep/ .ant-message {
    z-index: 9999 !important;
}
/deep/ .el-dialog{
  min-width: 400px;
}
</style>